import React from "react";
import Link from "next/link";
import { ClipboardList, Phone } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const StickyContactIcons = () => {
  return (
    <div className="fixed right-3 top-[70dvh] z-50 flex -translate-y-1/2 flex-col gap-3 md:bottom-6 md:right-6 md:top-auto md:translate-y-0">
      <a
        href="tel:+917995792953"
        aria-label="Call Servani Safety Nets at +91 79957 92953"
        className="flex h-14 w-16 flex-col items-center justify-center gap-0.5 rounded-xl border border-white/30 bg-[#0369a1] text-white shadow-[0_8px_24px_rgba(3,105,161,0.34)] transition hover:-translate-y-0.5 hover:bg-[#075985] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0369a1] md:size-12 md:rounded-full"
      >
        <Phone className="size-5" aria-hidden="true" />
        <span className="text-[9px] font-extrabold tracking-wide uppercase md:hidden">Call</span>
      </a>
      <a
        href="https://wa.me/917995792953"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Servani Safety Nets on WhatsApp"
        className="flex h-14 w-16 flex-col items-center justify-center gap-0.5 rounded-xl border border-white/30 bg-[#1f7a60] text-white shadow-[0_8px_24px_rgba(31,122,96,0.34)] transition hover:-translate-y-0.5 hover:bg-[#17634e] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1f7a60] md:size-12 md:rounded-full"
      >
        <FaWhatsapp className="size-5" aria-hidden="true" />
        <span className="text-[9px] font-extrabold tracking-wide uppercase md:hidden">WhatsApp</span>
      </a>
      <Link
        href="/contactUs"
        aria-label="Request a free safety net quote"
        className="flex h-14 w-16 flex-col items-center justify-center gap-0.5 rounded-xl border border-white/30 bg-[#0c4a6e] text-white shadow-[0_8px_24px_rgba(8,47,73,0.34)] transition hover:-translate-y-0.5 hover:bg-[#082f49] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0c4a6e] md:size-12 md:rounded-full"
      >
        <ClipboardList className="size-5" aria-hidden="true" />
        <span className="text-[9px] font-extrabold tracking-wide uppercase md:hidden">Free quote</span>
      </Link>
    </div>
  );
};

export default StickyContactIcons;
